export default __webpack_public_path__ + "static/media/icSendTo.15321e7e.svg";